import { Colors, Loading } from '@helloself/hello-self-ui';
import React from 'react';

import { Background } from './components/background/Background';

export function UnauthSuspense() {
    return (
        <Background>
            <Loading color={Colors.MemberGreen700} />
        </Background>
    );
}
